module.exports = "/_next/static/images/hero-bg-dark-1be038efb060f90fee0779be43f58516.png.webp";